export default __webpack_public_path__ + "static/media/logoipsum-logo-39.3e700edc.svg";